import {Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {StoreService} from '../../shared';

export type PopoverPlacement = 'top' | 'bottom' | 'left' | 'right';

export interface IPopoverPosition {
    top?: string;
    bottom?: string;
    left?: string;
    right?: string;
}

export interface IPopoverSize {
    width?: string;
    height?: string;
}

@Component({
    selector: 'popover',
    templateUrl: './popover.component.html',
    styleUrls: ['./popover.component.css']
})
export class PopoverComponent implements OnChanges, OnInit {

    @Input() id: string;
    @Input() alignWithTarget: boolean;
    @Input() open: boolean;
    @Input() isTooltip: boolean;
    @Input() placement: PopoverPlacement;
    @Input() style: any;
    // @Input() size: IPopoverSize;
    @Input() sizeClass: string;
    @Output() onClose: EventEmitter<string>;
    position: IPopoverPosition;
    arrowLeft: string;
    isPopoverOpen: boolean;
    isTriggerClicked: boolean;
    isPopoverClicked: boolean;

    constructor(private store: StoreService, private el: ElementRef) {
        this.alignWithTarget = false;
        this.open = false;
        this.isTooltip = false;
        this.isPopoverOpen = false;
        this.isTriggerClicked = false;
        this.isPopoverClicked = false;
        this.placement = 'bottom';
        this.onClose = new EventEmitter();
        this.style = {};
        this.position = {top: '0px', left: '0px'};
        this.arrowLeft = '50%';
        // this.size = {width: '300px', height: 'auto'};
        this.sizeClass = 'popover-md';
    }

    ngOnInit() {

        this.store.get('onBodyClick').subscribe((evt) => {

            if (this.isPopoverClicked) {
                this.isPopoverClicked = false;
                return;
            }

            if (this.isTriggerClicked && !this.isTooltip) {
                if (this.isPopoverOpen) {
                    this.closePopover();
                } else {
                    this.openPopover(evt);
                }
            } else {
                this.closePopover();
            }

            this.isPopoverClicked = false;
        });
    }

    ngOnChanges(changes) {
        console.log('qqq this.ngOnChange called, this.open = ', this.open);
        this.isTriggerClicked = this.open;

        if (this.isTooltip) {
            if (this.open) {
                // this.openPopover()
            }
        }
    }

    onPopoverMouseOver(evt) {
        console.log('qqq evt = ', evt);
        this.openPopover(evt);
    }

    onPopoverMouseOut(evt) {
        this.closePopover();
    }

    onPopoverClick() {
        this.isPopoverClicked = true;
        console.log('qqq popover clicked');
    }

    openPopover(evt: MouseEvent) {
        const rightMargin = 40, leftMargin = 40, popoverIndent = -80;
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        const targetElement: HTMLElement = evt.target as HTMLElement;
        const targetBounds = targetElement.getBoundingClientRect();

        console.log('qqq targetElement = ', targetElement);
        console.log('qqq targetBounds = ', targetBounds);

        const popoverElement: HTMLElement = this.el.nativeElement.querySelector('.popover');
        const popoverBounds = popoverElement.getBoundingClientRect();

        let popoverX;
        let popoverY;

        if (this.alignWithTarget) {
            popoverX = Math.min((targetBounds.left + (targetBounds.width / 2)) + popoverIndent, window.innerWidth - rightMargin - popoverBounds.width);
            popoverY = targetBounds.top + targetBounds.height + scrollTop;
            this.arrowLeft = (targetBounds.left + (targetBounds.width / 2)) - popoverX + 'px';

            console.log('qqq popoverX = ', popoverX);
            console.log('qqq popoverY = ', popoverY);

        } else {
            popoverX = Math.min(evt.clientX + popoverIndent, window.innerWidth - rightMargin - popoverBounds.width);
            popoverY = evt.clientY + scrollTop;
            this.arrowLeft = (evt.clientX - popoverX) + 'px';
        }
        popoverX = popoverX + 'px';
        popoverY = popoverY + 'px';

        // console.log('qqq popoverBounds = ', popoverBounds.width);
        // console.log('qqq window.innerWidth = ', window.innerWidth);
        // console.log('qqq evt.clientX = ', evt.clientX);
        // console.log('qqq window.innerWidth - rightMargin - popoverBounds.width = ', window.innerWidth - rightMargin - popoverBounds.width);

        switch (this.placement) {
            case 'top':
                this.position.top = 'auto';
                this.position.bottom = popoverY;
                this.position.left = popoverX;
                break;
            case 'bottom':
                this.position.top = popoverY;
                this.position.bottom = 'auto';
                this.position.left = popoverX;
                break;
            case 'left':
                this.position.right = evt.clientX + 'px';
                break;
            case 'right':
                this.position.left = evt.clientX + 'px';
                break;
            default:
                this.position.top = evt.clientY + 'px';
                break;
        }

        this.style = Object.assign({}, this.style, this.position);
        this.isPopoverOpen = true;
    }

    closePopover() {
        this.isPopoverOpen = false;
        this.isTriggerClicked = false;
        this.position.top = '-100000px';
        this.style = Object.assign({}, this.style, this.position);
        this.onClose.emit(this.id);
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/popover/popover.component.ts